<template>
    <ai-grid-edit
        ref='gridRef'
        :args="args"
        :meta="gridMeta"
        :to-remove-toolbar-items-names='fromCard ? ["edit"] : undefined'
        @user-data-changed='onUserDataChanged'
        @toolbar-button-click='onToolbarClick'
    />
</template>
<script>
export default {
    name: 'qs-ctp-kaz-view',
};
</script>
<script setup>
import { computed, onMounted, ref } from 'vue';
import { getCookie } from '@/utils/cookies';

const props = defineProps({
    fromCard: {
        type: Boolean,
        default: () => false,
    }
});

const emits = defineEmits(['choose-ctp']);

const commonArgs = {
    depId: +getCookie('dep'),
    login: getCookie('login')
};

const args = {
    select: {
        select_args: {...commonArgs}
    },
    save: {
        update_args: {...commonArgs},
        insert_args: {...commonArgs},
        delete_args: {...commonArgs}
    }
};

const gridRef = ref(null);
const selectedRow = ref(null);
const gridMeta = computed(() => ({...meta}))

onMounted(async () => {
    await gridRef.value?.setDataSource();
});

const onUserDataChanged = async (event) => {
    if (props.fromCard) {
        const selectedKeys = event.changes.selectedRowKeys;
        const gridData = await gridRef.value?.getGridDataSource();
        selectedRow.value = gridData.filter(item => selectedKeys.includes(item.kod_ctp));
    }
};

const beforeNsiClose = async () => {
    const canClose = await gridRef.value?.checkBeforeClose();
    if (canClose) emits('choose-ctp', selectedRow.value);
};

const onToolbarClick = (event) => {
    if (event.item.component.name === 'choice') {
        beforeNsiClose();
    }
};

defineExpose({
    beforeNsiClose
});

const meta = {
    "keyExpr": "kod_ctp",
    "columns": [
        {
            "name": "kod_ctp",
            "caption": "№",
            "dataField": "kod_ctp",
            "allowEditing": false,
            "width": '15%',
            "index": 1,
            "visible": true
        },
        {
            "name": "name",
            "caption": "Наименование",
            "dataField": "name",
            "allowEditing": true,
            "width": '25%',
            "index": 2,
            "visible": true
        },
        {
            "name": "str_adr",
            "caption": "Адрес",
            "dataField": "str_adr",
            "allowEditing": true,
            "width": '25%',
            "index": 3,
            "visible": true
        },
        {
            "name": "str_reg",
            "caption": "Эксплуатационный район",
            "dataField": "str_reg",
            "allowEditing": true,
            "width": '25%',
            "index": 4,
            "visible": true
        },
        {
            "name": "pr_ctp_bez",
            "caption": "Признак безхозного ЦТП",
            "dataField": "pr_ctp_bez",
            "allowEditing": true,
            "dataType": "boolean",
            "width": '10%',
            "index": 5,
            "visible": true
        }
    ],
    "api": {
        "select": "core./core/qs-ctp-kaz-select/get",
        "save": "core./core/qs-ctp-kaz-save/set"
    },
    "viewId": "qs-ctp-kaz-view"
}
</script>
<style scoped></style>
